if (!customElements.get('wls-klaviyo-sms-email-form')) {
  class WLSKlaviyoSMSEmailForm extends HTMLElement {
    constructor() {
      super();

      this.classes = {
        emailForm: 'js-email-form',
        smsForm: 'js-sms-form',
        emailLabel: 'js-email-label',
        smsLabel: 'js-sms-label',
        radioButton: 'js-radio-button',
        activeClass: 'active',
      }

      this.formTypes = {
        EMAIL: 'email',
        SMS: 'sms',
      }

      this.handleRadioButtonChange = this.handleRadioButtonChange.bind(this);
    }

    get elements() {
      return {
        emailForm: this.querySelector(`.${this.classes.emailForm}`),
        smsForm: this.querySelector(`.${this.classes.smsForm}`),
        emailLabel: this.querySelector(`.${this.classes.emailLabel}`),
        smsLabel: this.querySelector(`.${this.classes.smsLabel}`),
        radioButtons: this.querySelectorAll(`.${this.classes.radioButton}`),
      }
    }

    connectedCallback() {
      this.elements.radioButtons.forEach((radioButton) => {
        radioButton.addEventListener('change', this.handleRadioButtonChange);
      });
      this.syncActiveFormFromSelection();
    }

    disconnectedCallback() {
      this.elements.radioButtons.forEach((radioButton) => {
        radioButton.removeEventListener('change', this.handleRadioButtonChange);
      });
    }

    syncActiveFormFromSelection() {
      const checked = this.querySelector(
        `.${this.classes.radioButton}:checked`
      );
      if (!checked) return;
      this.applyFormType(checked.value.toLowerCase());
    }

    applyFormType(formType) {
      const { activeClass } = this.classes;
      const { emailForm, smsForm, emailLabel, smsLabel } = this.elements;

      if (formType === this.formTypes.EMAIL) {
        emailForm?.classList.add(activeClass);
        smsForm?.classList.remove(activeClass);
        emailLabel?.classList.add(activeClass);
        smsLabel?.classList.remove(activeClass);
      } else if (formType === this.formTypes.SMS) {
        smsForm?.classList.add(activeClass);
        emailForm?.classList.remove(activeClass);
        smsLabel?.classList.add(activeClass);
        emailLabel?.classList.remove(activeClass);
      }
    }

    handleRadioButtonChange(event) {
      const formType = event.target.value.toLowerCase();
      this.applyFormType(formType);
    }
  }
  customElements.define('wls-klaviyo-sms-email-form', WLSKlaviyoSMSEmailForm);
}